import { submitNotify } from '@/lib/notify';

const PREMIUM_KEY = 'rm:premium:v1';

export function isPremium(): boolean {
  try {
    return localStorage.getItem(PREMIUM_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Captures the address behind the "I'm here" unlock and, only if the API took
 * it, marks the device as unlocked.
 *
 * The unlock panel promises a one-time link to re-open the mode elsewhere. If
 * the capture fails there is no link and no record, so we neither persist the
 * flag nor let the caller claim success — the caller shows a retry instead.
 *
 * @param countryCode ISO-3166 alpha-2 of the map the visitor is actually on.
 *        It used to be hard-coded to `'IT'`, which was right only because
 *        Italy was the only map: every address captured on /es/map or /pt/map
 *        would have been filed under Italy, and nothing in the UI would have
 *        shown it. The caller passes the route's country instead.
 * @returns `true` when the address was accepted (2xx), `false` otherwise.
 */
export async function unlockPremium(email: string, countryCode: string): Promise<boolean> {
  const ok = await submitNotify({
    email,
    countryCode,
    source: 'premium',
    context: { feature: 'visit-planner-imhere' },
  });
  if (!ok) return false;
  try {
    localStorage.setItem(PREMIUM_KEY, '1');
  } catch {
    // localStorage may be unavailable (quota / private mode). Premium flag
    // will simply not persist this session — non-fatal, the capture landed.
  }
  return true;
}
